import Cookies from 'js-cookie';

class CookieService {
  static setCookie(name: string, value: string, days?: number) {
    const options = days ? { expires: days } : undefined;
    Cookies.set(name, value, options);
  }

  static getCookie(name: string): string | undefined {
    return Cookies.get(name);
  }

  static deleteCookie(name: string) {
    Cookies.remove(name);
  }
}

export default CookieService;